import { createContext, useContext } from "react";

type GlobalManualLocationOrderContextType = {
	enabled: boolean;
	setEnabled: (enabled: boolean) => void;
	/** Ordered location names. Only meaningful when enabled=true. */
	orderedLocationNames: string[];
	setOrderedLocationNames: (names: string[]) => void;
	/** Pre-built Map<locationName, index> for sorting. null when disabled. */
	customStringOrderMap: Map<string, number> | null;
	/** Cancel any pending debounced save. */
	cancelPendingUpdate: () => void;
};

export const GlobalManualLocationOrderContext = createContext<GlobalManualLocationOrderContextType | null>(null);

export const useGlobalManualLocationOrder = () => {
	const context = useContext(GlobalManualLocationOrderContext);

	if (!context) throw new Error("useGlobalManualLocationOrder must be used within a GlobalManualLocationOrderProvider");

	return context;
};
